import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-13" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "text-muted fw-bold fs-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "d-none d-md-flex justify-content-center" }
const _hoisted_6 = { class: "d-flex d-md-none flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "View Invitation",
    size: "modal-lg",
    ref: "modal",
    "has-header": false,
    "has-toolbar": true,
    "is-loading": _ctx.isLoading,
    "loading-text": "Please Wait"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, "Invitation to join " + _toDisplayString(_ctx.invitation.entityName), 1),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" You've been invited to join " + _toDisplayString(_ctx.invitation.entityName) + "! ", 1),
          _hoisted_4,
          _createTextVNode("By accepting this invitation, managers will be able to see your email, phone number, medical notes & emergency contacts. Everyone can only see your full name, pronouns, title and photo. ")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit(false))),
          type: "secondary",
          class: "me-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Decline")
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(true))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Accept")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(true))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Accept")
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(false))),
          type: "secondary",
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Decline")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}